import React from 'react';
import { AddressType } from '@bizapp-lp/pjr/molecules/ZipcodeInput';
import { ValidationType } from '@bizapp-lp/pjr/molecules/Validation';

export type InputType =
  | 'checkboxGroup'
  | 'fileupload'
  | 'input'
  | 'radioGroup'
  | 'sectionTitle'
  | 'select'
  | 'text'
  | 'zipcode';

export type SizeType = 'short' | 'medium' | 'long-area' | 'long';

export type StylingProps = {
  size?: SizeType;
  textAlign?: string;
};

export interface InputComponentProps {
  kind?: InputType;
  style?: StylingProps;

  id: string;
  label?: React.ReactNode;
  required?: boolean;
  helperText?: React.ReactNode;
  description?: React.ReactNode;
  value?: any;
  disabled?: boolean;
  error?: boolean;
  hidden?: boolean;
  onChange?: (value: any) => void;

  valueFile?: File | null | string;
  onChangeFile?: (file: File | null) => void;
  acceptMIMETypes?: string[];

  type?: string;
  name?: string;
  warning?: boolean;
  autoCapitalize?: string;
  autoCorrect?: string;
  onBlur?: (value: string) => void;
  multiline?: boolean;
  rows?: number;

  radioOptions?: Map<string, React.ReactNode>;

  selectOptions?: Map<string, React.ReactNode>;

  onSelectZipcode?: (addr: AddressType) => void;

  items?: Map<string, string>;
}

export interface InputState {
  id: string;
  value: any;
  required: boolean;
  disabled: boolean;
  error: boolean;
  hidden: boolean;
  warning: boolean;
}
export const DefaultInputState = {
  id: 'default',
  value: '',
  required: false,
  disabled: false,
  error: false,
  hidden: false,
  warning: false,
};

export interface InputProps extends InputComponentProps {
  logicOptions?: {
    validationType?: ValidationType;

    prefectureId?: string;
    addressId?: string;

    toggleType?: 'none' | 'disable' | 'hide';
    toggleCopyMap?: Map<string, string>;
  };
}
